import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HierarchyCommonModule } from '®shared/hierarchy';
import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { ReadingListModule } from '../../models/reading-list.module';

import { HierarchyAndStudentNumbersService } from './hierarchy-and-student-numbers.service';

@NgModule({
  imports: [
    CommonModule,
    HierarchyCommonModule,
    ReadingListModule,
    TarlV3JsonapiModule,
  ],
  providers: [HierarchyAndStudentNumbersService],
})
export class ListNodesModule {}
